export const convertTimeFormat = (time) => {
  if (!time) {
    return "Invalid date";
  }

  const date = new Date(time);

  if (isNaN(date.getTime())) {
    return "Invalid date";
  }

  const options = {
    month: "numeric",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    hour12: true,
  };

  const formattedDate = new Intl.DateTimeFormat("en-US", options).format(date);
  return formattedDate;
};
